export function getPreviousLocation(state: { prevLocation: string } | undefined) {
  return state ? state.prevLocation || "" : "";
}

export const navItems = [
  { label: "ARTICLE", path: "/" },
  { label: "TEAM", path: "/team" },
  { label: "PHILOSOPHY", path: "/philosophy" },
];
